import React, { useState, useEffect } from "react";
import { Alert, Flex, Typography } from "antd";
import "./styles.scss";
import { WarningOutlined } from "@ant-design/icons";

const OfflineBanner = ({ style, text, isCreator }) => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	function setOffline() {
		// Function to update the online status
		const updateOnlineStatus = () => {
			setIsOnline(navigator.onLine);
			document.body.style.pointerEvents = navigator.onLine ? "auto" : "none";
			const dialogs = document.getElementsByClassName("ant-modal-content");
			for (let item of dialogs) {
				item.style.pointerEvents = navigator.onLine ? "auto" : "none";
			}
		};

		// Add event listeners for online and offline events
		window.addEventListener("online", updateOnlineStatus);
		window.addEventListener("offline", updateOnlineStatus);

		// Cleanup the event listeners when the component unmounts
		return () => {
			window.removeEventListener("online", updateOnlineStatus);
			window.removeEventListener("offline", updateOnlineStatus);
		};
	}

	useEffect(() => {
		const offline = setOffline();
		return offline;
	}, []);

	if (isOnline) {
		return null;
	}

	return (
		<Alert
			type="error"
			className="error-alert"
			banner
			style={{ position: "sticky", top: isCreator ? 56 : 0, zIndex: 99, left: 0, width: "100%", padding: 9, ...style }}
			showIcon={false}
			description={
				<Flex gap={8} justify="center">
					<WarningOutlined style={{ fontSize: 20, color: "#DC2626" }} />
					<Typography.Text>{text || "You are Currently Offline. Your changes may not be saved."}</Typography.Text>
				</Flex>
			}
		/>
	);
};

export default OfflineBanner;

